export const environment = {
  production: true,
  name: 'prod',
  enableServiceWorker: true,
  // introduced custom domain in 2026-09, app also accessible under Firebase default URL https://sbb-dispo.web.app
  siteUrl: 'https://app.dispo.sbb.ch',
  firebase: {
    apiKey: 'AIzaSyDG75uVxNfOY0c9PNCd8AY_qKCRrdOUG_U',
    authDomain: 'sbb-dispo.firebaseapp.com',
    databaseURL: 'https://sbb-dispo.firebaseio.com',
    projectId: 'sbb-dispo',
    storageBucket: 'sbb-dispo.appspot.com',
    messagingSenderId: '189715359764',
    appId: '1:189715359764:web:41e36af9fd8bc569b81f01'
  },
  // STRICH: conradin.lietha@sbb.ch
  // eslint-disable-next-line max-len
  strichLicenseKey: 'eyJhbGciOiJFZERTQSIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhYjExNTcyMC1lYmQ4LTQyNTktYTY3Mi04NDZlYmU5OWQxNzciLCJpc3MiOiJzdHJpY2guaW8iLCJhdWQiOlsiaHR0cHM6Ly90dW4ucGl4ZWx2ZXJzZS5jaCIsImh0dHBzOi8vc2JiLWRpc3BvLWRldi53ZWIuYXBwIiwiaHR0cHM6Ly9zYmItZGlzcG8tdGVzdC53ZWIuYXBwIiwiaHR0cHM6Ly9zYmItZGlzcG8tZGV2LndlYi5hcHAiXSwiaWF0IjoxNzY1MTk3NTEyLCJuYmYiOjE3NjUxOTc1MTIsImNhcGFiaWxpdGllcyI6eyJvZmZsaW5lIjp0cnVlfSwidmVyc2lvbiI6MSwiZXhwIjoxODAzODU5MTk5fQ.UvK3Jc8IyzLQSPdWZ0LjFYLVw-bYpAa0Y2G2Xm4T-WathCJgrcMqztLJv6YwZcRxNlCM_NEenlqD4hmc-8yEAg',
  strichDebug: false,
  // Sentry (ops@pixelverse.ch)
  sentryDsn: 'https://137c0df687734f989e9a61288e0d73a9@o1164849.ingest.sentry.io/4505267052281856',
  locationNagIntervalMs: 5 * 60 * 1000
};
